import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventBus } from '@/lib/EventBus';

type CallbackFunction = (data?: any) => void;

@Component({})
export default class Form extends Vue {
    @Prop({}) formValues?: any;
    enterDisabled = false;
    isBlockForm = false;
    serverError: string | null = null;

    returnBefore() {
        console.info('returnBefore');
    }

    async blockQuery(callback: CallbackFunction) {
        if (this.isBlockForm) {
            return;
        }

        this.isBlockForm = true;
        await callback();
        this.isBlockForm = false;
    }

    public async save() {
        const shouldUpdate = this.formValues && Object.values(this.formValues).length > 0
        const action = shouldUpdate ? this.update : this.createNew

        try {
            await action();

            this.clearFormDirty();
            EventBus.$emit('form:saved');
        } catch (error) {
            EventBus.$emit('form:error', error);
        }
    }

    async update() {} // eslint-disable-line
    async createNew() {} // eslint-disable-line

    created() {
        if (!this.enterDisabled) {
            EventBus.$on('saveForm', this.save);
        }

        EventBus.$on('pressEsc', this.returnBefore);
    }

    beforeDestroy() {
        if (!this.enterDisabled) {
            EventBus.$off('saveForm', this.save);
        }

        EventBus.$off('pressEsc', this.returnBefore);
    }

    initValuesUpdateDetector(valuesFieldName = 'values') {
        const unwatch = this.$watch(valuesFieldName, () => {
            unwatch();

            this.$emit('update:dirty', true);
        }, { deep: true })
    }

    clearFormDirty() {
        this.$emit('update:dirty', false);
    }
}
